<template>
  <v-container class="py-0" fluid>
    <v-row>
      <v-col class="py-0 primary">
        <v-form class="subheader" style="height:100%">
          <v-row>
            <v-col cols="6" md="3" class="pr-0">
              <div class="subheader__field">
                <v-select
                  v-model="scope"
                  class="mr-2 br-0"
                  :placeholder="$lang.translate('general.filters.scope')"
                  :items="scopes"
                  item-text="name"
                  item-value="value"
                  solo
                  hide-details
                  dense
                  flat
                ></v-select>
              </div>
            </v-col>
            <v-col cols="6" md="3" class="pl-0 pr-1 pr-md-0">
              <div class="subheader__field">
                <v-select
                  v-model="field"
                  class="mr-2 br-0"
                  :placeholder="$lang.translate('general.filters.tracking')"
                  :items="trackings"
                  item-text="name"
                  item-value="value"
                  solo
                  hide-details
                  dense
                  flat
                ></v-select>
              </div>
            </v-col>
            <v-col cols="12" md="3" class="pr-3 pl-3 pl-md-0 pb-2 pt-1 pt-md-3">
              <div class="subheader__field">
                <v-text-field
                  v-model="track"
                  class="br-0"
                  :placeholder="$lang.translate('general.filters.number')"
                  autocomplete="csos"
                  solo
                  hide-details
                  dense
                  flat
                ></v-text-field>
              </div>
            </v-col>
            <v-col
              cols="12"
              md="1"
              class="d-flex d-md-block justify-center justify-start  pl-2 pr-4 pl-md-0 pr-md-0">
              <v-btn
                class="subheader__btn ml-2"
                width="32"
                min-width="32"
                height="32"
                color="#f7fcfc"
                type="submit"
                :disabled="searching"
                @click.prevent="search"
                depressed
                block
                tile
              >
                <v-icon size="20">mdi-magnify</v-icon>
              </v-btn>
            </v-col>
          </v-row>
          <v-spacer class="d-none d-md-block"></v-spacer>
        </v-form>
      </v-col>
    </v-row>

    <v-row v-if="result.uid && !hidePerType(['FINANCE'])">
      <v-col
        class="
          py-0
          subheader__bordered
          mt-2 pb-2 mt-md-0 pb-md-0 ml-0 ml-md-2
          align-center justify-center
          d-flex"
        cols="12"
        md="1"
        >
        <router-link
          :to="{ name: 'track.business-scope.details', query: $route.query }"
          class="font-weight-bold black--text">
          {{ _.get(order, 'system') }}
        </router-link>
      </v-col>
      <v-col class="py-0 subheader__bordered
        justify-center justify-md-start
        d-flex"
        cols="12"
        md="10"
      >
        <v-btn
          height="50"
          color="grey darken-4"
          :to="{ name: 'track.business-scope.details', query: $route.query }"
          tile
          x-small
          text
          depressed
        >{{ 'general.sections.details' | translate(Scope.name) }}</v-btn>
        <v-btn
          height="50"
          color="grey darken-4"
          :to="{ name: 'track.business-scope.events', query: $route.query }"
          tile
          x-small
          text
          depressed
        >
          <v-badge
            :color="events.length > 0 ? 'red' : 'rgba(0,0,0,0)'"
            :dot="events.length < 0 ? true : false"
            :value="events.length"
            :content="events.length"
            class="badgesScopeTrack">
            {{ 'general.sections.events' | translate(Scope.name) }}
          </v-badge>
        </v-btn>
        <v-btn
          height="50"
          color="grey darken-4"
          :to="{ name: 'track.business-scope.contents', query: $route.query }"
          tile
          x-small
          text
          depressed
        >
          <v-badge
            :color="contents.length > 0 ? 'red' : 'rgba(0,0,0,0)'"
            :dot="contents.length < 0 ? true : false"
            :value="contents.length"
            :content="contents.length"
            class="badgesScopeTrack">
            {{ 'general.sections.contents' | translate(Scope.name) }}
          </v-badge>
        </v-btn>
        <v-btn
          height="50"
          color="grey darken-4"
          :to="{ name: 'track.business-scope.documents', query: $route.query }"
          tile
          x-small
          text
          depressed
        >
          <v-badge
            :color="documents.length > 0 ? 'red' : 'rgba(0,0,0,0)'"
            :dot="documents.length < 0 ? true : false"
            :value="documents.length"
            :content="documents.length"
            class="badgesScopeTrack">
            {{ 'general.sections.documents' | translate(Scope.name) }}
          </v-badge>
        </v-btn>
        <v-btn
          height="50"
          color="grey darken-4"
          :to="{ name: 'track.business-scope.iot', query: $route.query }"
          v-translate="'general.sections.iot'"
          x-small
          text
          depressed
          v-if="(isScope('IBM') || isScope('KYNDRYL')) && hits.length && haveAccess"
        >
          IOT Tracking
        </v-btn>
        <v-btn
          height="50"
          color="grey darken-4"
          x-small
          text
          depressed
          disabled
          v-if="(isScope('IBM') || isScope('KYNDRYL')) && !hits.length && haveAccess"
        >
          IOT loading
          <v-progress-circular
            class="ml-2"
            indeterminate
            size="18"
            width="3"
          ></v-progress-circular>
        </v-btn>
      </v-col>
    </v-row>

    <router-view v-if="!hidePerType(['FINANCE']) && result.uid || orders.length"></router-view>

    <v-row class="mt-10 mb-5" v-if="result.uid && hidePerType(['FINANCE'])">
      <v-col class="text-center" cols="12" md="6" offset="0" offset-md="3">
        <v-icon size="40" color="black" class="mb-2">mdi-magnify</v-icon>
        <h2 class="title" v-translate="'search.notAvailable'">
          Your shipment tracking information is not yet available.
        </h2>
      </v-col>
    </v-row>

    <v-row class="mt-10 mb-5" v-if="!result.uid && !orders.length">
      <v-col class="text-center" cols="12" md="6" offset="0" offset-md="3">
        <v-icon size="40" color="black" class="mb-2">mdi-magnify</v-icon>
        <h2
          class="title"
          v-if="!searched"
          v-translate="'search.fill'"
        >
          Please fill the field to track your order.
        </h2>
        <h2 class="title" v-if="searched" v-translate="'search.notFound'">
          Your shipment tracking information is not yet available or your
          tracking reference is incorrect. Please try again later.
        </h2>
      </v-col>
    </v-row>
  </v-container>
</template>

<script>
import { mapState } from 'vuex';
import store from '@/store';
import router from '@/router';
import { fetchOrderBeforeEnter, fetchScope } from '@/helpers';
import {
  Mpo,
  Zenith,
  Setup,
} from '@/api';
import {
  keys,
  get,
  isEmpty,
} from 'lodash';
import {
  oftype,
  Parser,
} from '@/utils';

const hiddeable = ['LVMH'];

/**
 * @param {Route} to
 * @param {Object} scope
 */
async function searchBeforeEnter(to, _, __, scope) {
  if (to.matched.some(r => r.meta.order)) return Promise.reject();
  if (!isEmpty(to.query)) {
    store.commit('START_LOADING');
    const { data } = await ({ Mpo, Zenith }[scope.system]).search(to.query);
    const shipment = data;
    const formated = Parser.map(shipment, scope.system);
    return formated;
  }

  return { };
}

export default {
  name: 'app-business-scope-track',
  async beforeRouteEnter(...args) {
    const currentScope = await fetchScope(...args);
    store.commit('SET_SCOPE', currentScope);

    if (
      !args[0].matched.some(r => r.meta.order)
      && !isEmpty(args[0].query)
    ) {
      searchBeforeEnter(...args, currentScope)
        .then((results) => {
          if (oftype(results, 'Object')) {
            return router.push({
              name: 'track.business-scope.details',
              query: args[0].query,
              params: {
                scope: args[0].params.scope,
                number: get(results, 'system'),
              },
            });
          }
          args[2]((vm) => {
            /* eslint-disable */
            store.commit('CLEAR_ORDER');
            store.commit('END_LOADING');
            store.commit('SET_SEARCH', results);
            vm.searching = false;
            vm.currentScope = currentScope;
            if (!isEmpty(args[0].query)) vm.searched = true;
            /* eslint-enable */
          });

          return results;
        })
        .catch(err => console.debug('SEARCH ERR', err))
        .finally(() => {
          store.commit('END_LOADING');
          args[2]((vm) => {
            /* eslint-disable */
            vm.searching = false;
            vm.searched = true;
            vm.currentScope = currentScope;
            /* eslint-enable */
          });
        });
    } else if (
      !args[0].matched.some(r => r.meta.search)
      && (!args[1] || args[0].params.number !== args[1].params.number)
    ) {
      fetchOrderBeforeEnter(...args, currentScope)
        .then(() => args[2]((vm) => {
          /* eslint-disable */
          if (args[0].params.number) vm.searched = true;
          store.commit('CLEAR_SEARCH');
          store.commit('END_LOADING');
          vm.searching = false;
          vm.currentScope = currentScope;
          /* eslint-enable */
        }))
        .catch(err => console.debug('FETCH ERR', err))
        .finally(() => {
          store.commit('END_LOADING');
          args[2]((vm) => {
            /* eslint-disable */
            vm.searching = false;
            vm.searched = true;
            vm.currentScope = currentScope;
            /* eslint-enable */
          });
        });
    } else {
      store.commit('CLEAR_SEARCH');
      store.commit('CLEAR_ORDER');
      store.commit('END_LOADING');
      args[2]((vm) => {
        // eslint-disable-next-line
        vm.currentScope = currentScope;
      });
    }
  },
  async beforeRouteUpdate(...args) {
    if (
      !args[0].matched.some(r => r.meta.order)
      && !isEmpty(args[0].query)
    ) {
      searchBeforeEnter(...args, this.currentScope)
        .then((results) => {
          if (oftype(results, 'Object')) {
            return router.push({
              name: 'track.business-scope.details',
              query: args[0].query,
              params: {
                scope: args[0].params.scope,
                number: get(results, 'system'),
              },
            });
          }
          store.commit('CLEAR_ORDER');
          store.commit('END_LOADING');
          store.commit('SET_SEARCH', results);
          this.searching = false;
          if (!isEmpty(args[0].query)) this.searched = true;
          args[2]();

          return results;
        })
        .catch(err => console.debug('UPDATE SEARCH ERR', err))
        .finally(() => {
          this.$store.commit('END_LOADING');
          this.searching = false;
          this.searched = true;
          args[2]();
        });
    } else if (
      !args[0].matched.some(r => r.meta.search)
      && (!args[1] || args[0].params.number !== args[1].params.number)
    ) {
      fetchOrderBeforeEnter(...args, this.currentScope)
        .then(() => {
          if (args[0].params.number) this.searched = true;
          if (!args[0].params.number) store.commit('CLEAR_ORDER');
          store.commit('END_LOADING');
          this.searching = false;
          args[2]();
        })
        .catch(err => console.debug('UPDATE FETCH ERR', err))
        .finally(() => {
          this.$store.commit('END_LOADING');
          this.searching = false;
          this.searched = true;
          args[2]();
        });
    } else {
      this.$store.commit('END_LOADING');
      this.searching = false;
      args[2]();
    }
  },
  data() {
    return {
      copied: false,
      dialog: false,
      searched: false,
      searching: false,
      currentScope: { },
      scope: '',
      track: '',
      field: '',
      scopes: [],
      trackings: [],
    };
  },
  watch: {
    $route: {
      immediate: true,
      handler() {
        setTimeout(() => {
          /* eslint-disable */
          if (parent.window.document.querySelector('iframe')) {
            parent.window.document.querySelector('iframe').height = 0;
            parent.postMessage(
              window.document.body.offsetHeight,
              window.location.origin,
            );
          }
          /* eslint-enable */
        });
      },
    },
    async scope() {
      if (this.scopes && this.scopes.length) {
        const findThales = this.scopes.find(i => i.value.includes('SCO_THALES'));
        if (findThales) {
          const scopeThales = this.scopes[0];
          this.scope = scopeThales.value;
          const { data } = await Setup.fetch({
            guid: scopeThales.scopeId,
            type: 'Param',
            org: scopeThales.guid,
          });
          this.trackings = data.map(d => ({
            ...d,
            name: this.translateItem(d.value) || d.name,
          }));
        }
      }
      if (!this.scopeObj) return;
      const { data } = await Setup.fetch({
        guid: this.$route.params.scope,
        type: 'Param',
        org: this.scopeObj.guid,
      });
      this.trackings = data.map(d => ({
        ...d,
        name: this.translateItem(d.value) || d.name,
      }));
    },
  },
  computed: {
    ...mapState({
      admin: 'IsAdmin',
      haveAccess: 'IOTAccess',
      result: 'Order',
      results: 'Search',
      Scope: 'Scope',
    }),
    order() {
      return this.result;
    },
    orders() {
      const { results } = this;
      if (results) return oftype(results, 'Array') ? results : [results];
      return [];
    },
    events() {
      const { events } = this.result;
      if (events) {
        return (oftype(events, 'Array') ? events : [events])
          .filter(evt => get(evt, 'closeDate'));
      }
      return [];
    },
    documents() {
      const { documents } = this.result;
      if (documents) return oftype(documents, 'Array') ? documents : [documents];
      return [];
    },
    hits() {
      return this.order.hits || [];
    },
    contents() {
      let items = get(this.order, 'items', []);

      if (!oftype(items, 'Array')) items = [items];

      return items.reduce((acc, item) => {
        if (!~acc.indexOf(item.caseNumber)) acc.push(item.caseNumber);
        return acc;
      }, []);
    },
    scopeObj() {
      return this.scopes.find(s => s.value === this.scope);
    },
  },
  methods: {
    hidePerType(types = []) {
      if (hiddeable.includes(this.Scope.name)) {
        return types.includes(this.order.type);
      }

      return false;
    },
    translateItem(name) {
      if (['THALES'].find(n => this.scope.includes(n))) {
        return this.$lang.translate(`search.params.${name}`);
      }

      return null;
    },
    async search() {
      if (!this.field || !this.scope || !this.track) return;
      const field = keys(this.$route.query).find(q => q !== 'org');
      const same = (
        this.track.trim() === this.$route.query[field]
        && keys(this.$route.query).includes(this.field)
      );
      this.searching = true;

      if (!this.$route.params.number && same) {
        const results = await searchBeforeEnter(this.$route, null, null, this.currentScope)
          .catch(() => {
            this.$store.commit('END_LOADING');
            this.searching = false;
            this.searched = true;
          });
        store.commit('SET_SEARCH', results);
      } else if (this.$route.params.number && same) {
        await fetchOrderBeforeEnter(this.$route, null, null, this.currentScope)
          .catch(() => {
            this.$store.commit('END_LOADING');
            this.searching = false;
            this.searched = true;
          });
      } else {
        this.$router.push({
          name: 'business-scope.search',
          params: { scope: this.$route.params.scope },
          query: {
            [this.field]: this.track.toUpperCase().trim(),
            org: this.scope,
          },
        });
      }
      if (same) {
        this.searching = false;
        this.$store.commit('END_LOADING');
      }
    },
    async fetchSetup() {
      const { data: scopes } = await Setup.fetch({
        guid: this.$route.params.scope,
        type: 'Scope',
      });
      this.scopes = scopes;
    },
    isScope(scope) {
      return scope;
    },
  },
  async created() {
    this.fetchSetup().then(() => {
      const field = keys(this.$route.query).find(q => q !== 'org');
      this.scope = this.$route.query.org;
      this.track = this.$route.query[field] || '';
      this.field = field || '';
    });
  },
};
</script>
